import type { ChatRoom } from "@/react/components/Modals/MessagingModal/LeftSidebar/List/ChatRoomTypes";
import { DIRECT_CHAT_ROOM } from "@/react/components/constants";
import { useChatNotification } from "@/react/hooks/chatsV2/useChatNotification";
import type { CurrentCommunityMember } from "@/react/types/CurrentCommunityMember";
import { dateStringToTimeAgo } from "@circle-react/helpers/dateTimeHelpers/timeAgo";
import { usePopoverPortalContext } from "@circle-react-uikit/PopoverPortal";
import { Item } from "./Item";
import { ItemWrapper } from "./Item/ItemWrapper";

interface ChatRoomsListProps {
  chatRooms: ChatRoom[];
  currentCommunityMember: CurrentCommunityMember;
}

export const ChatRoomsList = ({
  chatRooms,
  currentCommunityMember,
}: ChatRoomsListProps) => {
  const { onClose } = usePopoverPortalContext() || {};
  const { unreadChatRoomUuids = [] } = useChatNotification();

  return (
    <>
      {chatRooms.map(
        ({
          chat_room_name,
          chat_room_kind,
          last_message,
          current_participant = {},
          other_participants_preview: otherParticipants = [],
          id,
          has_unread_messages,
          uuid,
          pinned_at,
        }) => {
          const isDirect = chat_room_kind === DIRECT_CHAT_ROOM;
          const isUnreadChatRoom = unreadChatRoomUuids.includes(uuid);
          const hasUnreadMessages = Boolean(
            has_unread_messages && isUnreadChatRoom,
          );
          return (
            <ItemWrapper key={id} onClose={onClose} uuid={uuid}>
              <Item
                chatRoomName={chat_room_name}
                lastMessage={last_message}
                currentParticipant={current_participant}
                otherParticipants={otherParticipants}
                isDirect={isDirect}
                hasUnreadMessages={hasUnreadMessages}
                timestamp={dateStringToTimeAgo(last_message?.created_at, {
                  format: "short",
                })}
                currentCommunityMember={currentCommunityMember}
                isPinned={!!pinned_at}
              />
            </ItemWrapper>
          );
        },
      )}
    </>
  );
};
